<template>
    <div class="comment-replies__item">
        <div class="comment-wrapper">
            <div class="comment" :id="idSelector">
                <CommentHeader :comment="comment"/>

                <div class="comment__content">

                    <CommentText :comment="comment"/>

                    <div class="comment__bottom">
                        <div class="comment__reply-show-more-wrapper" v-if="comment.answerCount"
                             @click="toggleAnswers">
                            <div class="comment__reply-show-more-btn"
                                 :class="{'comment__reply-show-more-btn--down': isAnswersShowing}"></div>
                            <div class="comment__reply-show-more">{{showMoreBtnText}}</div>
                        </div>

                        <ReplyBtn :replay-to-id="comment.id" v-if="isCommentShowing"/>

                        <MoreActionsBtn :comment="comment" v-if="isCommentShowing"/>

                        <LikeBtn :comment="comment" :is-mobile="true"/>
                    </div>
                </div>
            </div>
        </div>
        <transition name="comment-answer-transform">
            <div v-if="isAnswersShowing" class="comment-answer">
                <div class="comment-answer__top">
                    <Answer v-for="comment in showingAnswers"
                            :key="comment.id"
                            :comment="comment"/>
                </div>
                <div class="comment-answer__bottom" v-if="hasMoreAnswers">
                    <div class="comment-answer__next" v-if="showPartOfAnswers" @click="showNextAnswers">
                        <div class="comment-answer__next-icon"></div>
                        <div class="comment-answer__next-text">
                            Другие ответы
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="comment-reply-wrapper">
            <transition name="comment-input-fade">
                <Input :key="comment.id" :answer-to-id="comment.id"/>
            </transition>
        </div>
    </div>
</template>

<script>
    import {extractCommentByIds} from "VueApps/comments/services/extractCommentByIds";
    import Answer from "VueApps/comments/components/comment/Answer.vue";
    import CommentHeader from "VueApps/comments/components/comment/parts/CommentHeader.vue";
    import ReplyBtn from "VueApps/comments/components/comment/parts/ReplyBtn.vue";
    import MoreActionsBtn from "VueApps/comments/components/comment/parts/MoreActionsBtn.vue";
    import CommentText from "VueApps/comments/components/comment/parts/CommentText.vue";
    import LikeBtn from "VueApps/comments/components/comment/parts/LikeBtn.vue";
    import Input from "VueApps/comments/components/input/Input.vue";
    import {isCommentShowing} from "VueApps/comments/services/commentStatusResolver";
    import {getUniqueSelector} from "VueApps/comments/services/highlight";

    const DEFAULT_NUMBER_OF_SHOWING_COMMENTS = 2;

    export default {
        name: "RootComment",
        components: {
            MoreActionsBtn,
            ReplyBtn,
            CommentHeader,
            CommentText,
            Answer,
            Input,
            LikeBtn,
        },
        props: {
            comment: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                isAnswersShowing: true,
                showPartOfAnswers: true,
            }
        },
        computed: {
            answers: function () {
                return extractCommentByIds(
                    this.$store.state.componentState.comments,
                    this.$store.state.componentState.rootAnswerIds[this.comment.id]
                );
            },
            showingAnswers: function () {
                if (!this.hasMoreAnswers) {
                    return this.answers;
                }

                return this.showPartOfAnswers ?
                    this.slicePartOfComments :
                    this.answers;
            },
            slicePartOfComments: function () {
                return this.answers.slice(0, DEFAULT_NUMBER_OF_SHOWING_COMMENTS)
            },
            hasMoreAnswers: function () {
                return this.comment.answerCount > DEFAULT_NUMBER_OF_SHOWING_COMMENTS;
            },
            showMoreBtnText: function () {
                if (this.isAnswersShowing) {
                    return 'Скрыть ответы';
                }

                return 'Показать ответы';
            },
            idSelector: function () {
                return getUniqueSelector(this.comment.id);
            },
            isCommentShowing: function () {
                return isCommentShowing(this.comment);
            },
        },
        methods: {
            toggleAnswers: function () {
                this.isAnswersShowing = !this.isAnswersShowing;
            },
            showNextAnswers: function () {
                this.showPartOfAnswers = !this.showPartOfAnswers;
            },
        }
    }
</script>

<style scoped>

</style>
